import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { Badge } from '../../ui/badge';

export default function MapDetailCard({ location, onClose }) {
  if (!location) return null;

  const { city, state, job, pillar, client, status } = location;
  const cityState = state ? `${city}, ${state}` : city;
  const statusLabel = status === 'current' ? 'Active' : 'Completed';

  const rows = [
    { label: 'Market Sector', value: pillar },
    { label: 'Client', value: client },
    { label: 'Status', value: statusLabel },
  ].filter((r) => r.value);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mt-5 p-6 rounded-xl bg-coal-2 border border-white/8 shadow-elev-1"
      data-testid="map-location-detail"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-4 flex-wrap">
            <h3 className="font-display font-semibold text-xl text-bone leading-tight">
              {cityState}
            </h3>
            <Badge
              variant="secondary"
              className="font-mono text-[10px] tracking-[0.18em] uppercase bg-primary/20 text-[hsl(154_60%_60%)] border-primary/40"
            >
              Job #{job}
            </Badge>
          </div>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
            {rows.map((r) => (
              <div key={r.label} data-testid={`map-detail-${r.label.toLowerCase().replace(/\s+/g, '-')}`}>
                <dt className="font-mono text-[10px] tracking-[0.2em] uppercase text-bone/45 mb-1">
                  {r.label}
                </dt>
                <dd className="text-sm text-bone/85 leading-snug">{r.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <button
          onClick={onClose}
          className="text-bone/40 hover:text-bone transition-colors p-1"
          data-testid="map-location-close"
          aria-label="Close project detail"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
}
